export const makeId = (url) => url.replace("https://www.lonelyplanet.com/", "");

export const bookings = [
  { url: "https://www.lonelyplanet.com/travel-insurance", name: "Insurance" },
  { url: "https://www.lonelyplanet.com/hotels", name: "Hotels" },
  { url: "https://www.lonelyplanet.com/flights", name: "Flights" },
  {
    url: "https://www.lonelyplanet.com/adventure-tours",
    name: "Adventure tours",
  },
  {
    url: "https://www.lonelyplanet.com/sightseeing-tours",
    name: "Sightseeing tours",
  },
  { url: "https://www.lonelyplanet.com/car-rental", name: "Car rental" },
];

export const cities = {
  cuba: [
    { name: "Havana", url: "https://www.lonelyplanet.com/cuba/havana" },
    { name: "Varadero", url: "https://www.lonelyplanet.com/cuba/varadero" },
    { name: "Cienfuegos", url: "https://www.lonelyplanet.com/cuba/cienfuegos" },
    {
      name: "Santiago de Cuba",
      url: "https://www.lonelyplanet.com/cuba/eastern-cuba/santiago-de-cuba",
    },
    {
      name: "Trinidad",
      url: "https://www.lonelyplanet.com/cuba/central-cuba/trinidad",
    },
    {
      name: "Viales",
      url: "https://www.lonelyplanet.com/cuba/pinar-del-rio-province/vinales",
    },
    {
      name: "Santa Clara",
      url: "https://www.lonelyplanet.com/cuba/central-cuba/santa-clara",
    },
    { name: "Camagey", url: "https://www.lonelyplanet.com/cuba/camaguey" },
    {
      name: "Playas del Este",
      url: "https://www.lonelyplanet.com/cuba/playas-del-este",
    },
    { name: "Holgun", url: "https://www.lonelyplanet.com/cuba/holguin" },
    { name: "Matanzas", url: "https://www.lonelyplanet.com/cuba/matanzas" },
    {
      name: "Baracoa",
      url: "https://www.lonelyplanet.com/cuba/eastern-cuba/baracoa",
    },
  ],
  guatemala: [
    { name: "Antigua", url: "https://www.lonelyplanet.com/guatemala/antigua" },
    {
      name: "Guatemala City",
      url: "https://www.lonelyplanet.com/guatemala/guatemala-city",
    },
    {
      name: "Quetzaltenango",
      url:
        "https://www.lonelyplanet.com/guatemala/western-highlands/quetzaltenango-xela",
    },
    {
      name: "Chichicastenango",
      url:
        "https://www.lonelyplanet.com/guatemala/the-highlands-quiche/chichicastenango",
    },
    {
      name: "Panajachel",
      url:
        "https://www.lonelyplanet.com/guatemala/the-highlands-lago-de-atitlan/panajachel",
    },
    {
      name: "San Pedro la Laguna",
      url:
        "https://www.lonelyplanet.com/guatemala/the-highlands-lago-de-atitlan/san-pedro-la-laguna",
    },
    {
      name: "San Marcos la Laguna",
      url:
        "https://www.lonelyplanet.com/guatemala/the-highlands-lago-de-atitlan/san-marcos-la-laguna",
    },
  ],
  canada: [
    { name: "Montreal", url: "https://www.lonelyplanet.com/canada/montreal" },
    { name: "Vancouver", url: "https://www.lonelyplanet.com/canada/vancouver" },
    { name: "Toronto", url: "https://www.lonelyplanet.com/canada/toronto" },
    {
      name: "Quebec City",
      url: "https://www.lonelyplanet.com/canada/quebec-city",
    },
    {
      name: "Victoria",
      url: "https://www.lonelyplanet.com/canada/british-columbia/victoria",
    },
    {
      name: "Lake Louise",
      url: "https://www.lonelyplanet.com/canada/alberta/lake-louise",
    },
    {
      name: "Edmonton",
      url: "https://www.lonelyplanet.com/canada/alberta/edmonton",
    },
    {
      name: "Halifax",
      url: "https://www.lonelyplanet.com/canada/nova-scotia/halifax",
    },
    {
      name: "Ottawa",
      url: "https://www.lonelyplanet.com/canada/ontario/ottawa",
    },
    {
      name: "Vancouver",
      url:
        "https://www.lonelyplanet.com/canada/british-columbia/vancouver/gastown-chinatown",
    },
    {
      name: "Calgary",
      url: "https://www.lonelyplanet.com/canada/alberta/calgary",
    },
    {
      name: "Yellowknife",
      url:
        "https://www.lonelyplanet.com/canada/northwest-territories/yellowknife",
    },
    {
      name: "Niagara Falls",
      url: "https://www.lonelyplanet.com/canada/ontario/niagara-falls",
    },
    {
      name: "Charlottetown",
      url:
        "https://www.lonelyplanet.com/canada/prince-edward-island/charlottetown",
    },
    {
      name: "St Johns",
      url:
        "https://www.lonelyplanet.com/canada/newfoundland-and-labrador/st-johns",
    },
    {
      name: "Whistler",
      url: "https://www.lonelyplanet.com/canada/british-columbia/whistler",
    },
    {
      name: "Banff Town",
      url: "https://www.lonelyplanet.com/canada/alberta/banff-town",
    },
    {
      name: "Whitehorse",
      url: "https://www.lonelyplanet.com/canada/yukon-territory/whitehorse",
    },
    {
      name: "Tofino",
      url:
        "https://www.lonelyplanet.com/canada/british-columbia/tofino-and-around",
    },
    {
      name: "Nanaimo",
      url: "https://www.lonelyplanet.com/canada/british-columbia/nanaimo",
    },
    {
      name: "Kamloops",
      url: "https://www.lonelyplanet.com/canada/british-columbia/kamloops",
    },
    {
      name: "Churchill",
      url: "https://www.lonelyplanet.com/canada/manitoba/churchill",
    },
    {
      name: "Baie St Paul",
      url: "https://www.lonelyplanet.com/canada/quebec/baie-st-paul",
    },
    {
      name: "Tadoussac",
      url: "https://www.lonelyplanet.com/canada/quebec/tadoussac",
    },
    {
      name: "Winnipeg",
      url: "https://www.lonelyplanet.com/canada/manitoba/winnipeg",
    },
    {
      name: "Kelowna",
      url: "https://www.lonelyplanet.com/canada/british-columbia/kelowna",
    },
    {
      name: "Canmore",
      url: "https://www.lonelyplanet.com/canada/alberta/canmore",
    },
    {
      name: "Drumheller",
      url: "https://www.lonelyplanet.com/canada/alberta/drumheller",
    },
  ],
  mexico: [
    {
      name: "Mexico City",
      url: "https://www.lonelyplanet.com/mexico/mexico-city",
    },
    {
      name: "Oaxaca City",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/oaxaca",
    },
    {
      name: "Cabo San Lucas",
      url: "https://www.lonelyplanet.com/mexico/baja-california/cabo-san-lucas",
    },
    {
      name: "Tulum",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/tulum",
    },
    { name: "Cancn", url: "https://www.lonelyplanet.com/mexico/cancun" },
    {
      name: "Puerto Vallarta",
      url: "https://www.lonelyplanet.com/mexico/puerto-vallarta",
    },
    {
      name: "Guadalajara",
      url:
        "https://www.lonelyplanet.com/mexico/western-central-highlands/guadalajara",
    },
    {
      name: "Playa del Carmen",
      url:
        "https://www.lonelyplanet.com/mexico/yucatan-peninsula/playa-del-carmen",
    },
    {
      name: "San Miguel de Allende",
      url:
        "https://www.lonelyplanet.com/mexico/northern-central-highlands/san-miguel-de-allende",
    },
    {
      name: "Guanajuato",
      url:
        "https://www.lonelyplanet.com/mexico/northern-central-highlands/guanajuato",
    },
    {
      name: "Palenque",
      url: "https://www.lonelyplanet.com/mexico/tabasco-and-chiapas/palenque",
    },
    {
      name: "Puerto Escondido",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/puerto-escondido",
    },
    {
      name: "Zihuatanejo",
      url:
        "https://www.lonelyplanet.com/mexico/central-pacific-coast/zihuatanejo",
    },
    {
      name: "La Paz",
      url: "https://www.lonelyplanet.com/mexico/baja-california/la-paz",
    },
    {
      name: "Cabo Pulmo",
      url: "https://www.lonelyplanet.com/mexico/cabo-pulmo",
    },
    {
      name: "Mrida",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/merida",
    },
    {
      name: "San Cristbal de las Casas",
      url:
        "https://www.lonelyplanet.com/mexico/tabasco-and-chiapas/san-cristobal-de-las-casas",
    },
    {
      name: "Todos Santos",
      url: "https://www.lonelyplanet.com/mexico/baja-california/todos-santos",
    },
    {
      name: "Tijuana",
      url: "https://www.lonelyplanet.com/mexico/baja-california/tijuana",
    },
    {
      name: "Monterrey",
      url: "https://www.lonelyplanet.com/mexico/northeast-mexico/monterrey",
    },
    {
      name: "San Jos del Cabo",
      url:
        "https://www.lonelyplanet.com/mexico/baja-california/san-jose-del-cabo",
    },
    {
      name: "Puerto morelos",
      url:
        "https://www.lonelyplanet.com/mexico/yucatan-peninsula/puerto-morelos",
    },
    { name: "Akumal", url: "https://www.lonelyplanet.com/mexico/akumal" },
    {
      name: "Zipolite",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/zipolite",
    },
    {
      name: "Sayulita",
      url: "https://www.lonelyplanet.com/mexico/central-pacific-coast/sayulita",
    },
    {
      name: "Ensenada",
      url: "https://www.lonelyplanet.com/mexico/baja-california/ensenada",
    },
    {
      name: "Campeche",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/campeche",
    },
    {
      name: "Ro Lagartos",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/rio-lagartos",
    },
    {
      name: "Mahahual",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/mahahual",
    },
    {
      name: "Puebla",
      url: "https://www.lonelyplanet.com/mexico/east-of-mexico-city/puebla",
    },
    {
      name: "Loreto",
      url: "https://www.lonelyplanet.com/mexico/baja-california/loreto",
    },
    {
      name: "Quertaro",
      url:
        "https://www.lonelyplanet.com/mexico/northern-central-highlands/queretaro",
    },
    {
      name: "Mazatln",
      url: "https://www.lonelyplanet.com/mexico/central-pacific-coast/mazatlan",
    },
    {
      name: "Celestn",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/celestun",
    },
    {
      name: "Progreso",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/progreso",
    },
    {
      name: "Ixtapa",
      url: "https://www.lonelyplanet.com/mexico/central-pacific-coast/ixtapa",
    },
    {
      name: "Puerto Angel",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/puerto-angel",
    },
    {
      name: "Taxco",
      url: "https://www.lonelyplanet.com/mexico/south-of-mexico-city/taxco",
    },
    {
      name: "Veracruz City",
      url: "https://www.lonelyplanet.com/mexico/central-gulf-coast/veracruz",
    },
    {
      name: "Manzanillo",
      url:
        "https://www.lonelyplanet.com/mexico/central-pacific-coast/manzanillo",
    },
    {
      name: "Acapulco",
      url: "https://www.lonelyplanet.com/mexico/central-pacific-coast/acapulco",
    },
    {
      name: "San Agustinillo",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/san-agustinillo",
    },
    {
      name: "Morelia",
      url:
        "https://www.lonelyplanet.com/mexico/western-central-highlands/morelia",
    },
    {
      name: "Valladolid",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/valladolid",
    },
    {
      name: "Mazunte",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/mazunte",
    },
    {
      name: "Cuernavaca",
      url:
        "https://www.lonelyplanet.com/mexico/south-of-mexico-city/cuernavaca",
    },
    {
      name: "Barra de la Cruz",
      url: "https://www.lonelyplanet.com/mexico/oaxaca-state/barra-de-la-cruz",
    },
    {
      name: "Chetumal",
      url: "https://www.lonelyplanet.com/mexico/yucatan-peninsula/chetumal",
    },
  ],
  usa: [
    {
      name: "New York City",
      url: "https://www.lonelyplanet.com/usa/new-york-city",
    },
    {
      name: "San Francisco",
      url: "https://www.lonelyplanet.com/usa/san-francisco",
    },
    {
      name: "New Orleans",
      url: "https://www.lonelyplanet.com/usa/new-orleans",
    },
    {
      name: "Los Angeles",
      url: "https://www.lonelyplanet.com/usa/los-angeles",
    },
    { name: "Boston", url: "https://www.lonelyplanet.com/usa/boston" },
    {
      name: "Washington, D.C.",
      url: "https://www.lonelyplanet.com/usa/washington-dc",
    },
    { name: "Seattle", url: "https://www.lonelyplanet.com/usa/seattle" },
    { name: "Chicago", url: "https://www.lonelyplanet.com/usa/chicago" },
    { name: "Miami", url: "https://www.lonelyplanet.com/usa/miami" },
    { name: "San Diego", url: "https://www.lonelyplanet.com/usa/san-diego" },
    { name: "Nashville", url: "https://www.lonelyplanet.com/usa/nashville" },
    {
      name: "Portland",
      url: "https://www.lonelyplanet.com/usa/pacific-northwest/portland",
    },
    {
      name: "Sedona",
      url: "https://www.lonelyplanet.com/usa/southwest/sedona",
    },
    { name: "Las Vegas", url: "https://www.lonelyplanet.com/usa/las-vegas" },
    {
      name: "Honolulu",
      url: "https://www.lonelyplanet.com/usa/honolulu-and-waikiki",
    },
    {
      name: "Philadelphia",
      url: "https://www.lonelyplanet.com/usa/pennsylvania/philadelphia",
    },
    {
      name: "Denver",
      url: "https://www.lonelyplanet.com/usa/rocky-mountains/denver",
    },
    { name: "Austin", url: "https://www.lonelyplanet.com/usa/austin" },
    {
      name: "Minneapolis",
      url: "https://www.lonelyplanet.com/usa/great-lakes/minneapolis",
    },
    { name: "Houston", url: "https://www.lonelyplanet.com/usa/texas/houston" },
    {
      name: "Detroit",
      url: "https://www.lonelyplanet.com/usa/great-lakes/detroit",
    },
    { name: "Santa Fe", url: "https://www.lonelyplanet.com/usa/santa-fe" },
    { name: "Waikiki", url: "https://www.lonelyplanet.com/usa/hawaii/waikiki" },
    {
      name: "Atlanta",
      url: "https://www.lonelyplanet.com/usa/the-south/atlanta",
    },
    {
      name: "Key West",
      url: "https://www.lonelyplanet.com/usa/florida/key-west",
    },
    {
      name: "Charleston",
      url: "https://www.lonelyplanet.com/usa/the-south/charleston",
    },
    { name: "Dallas", url: "https://www.lonelyplanet.com/usa/texas/dallas" },
    {
      name: "Orlando",
      url: "https://www.lonelyplanet.com/usa/florida/orlando",
    },
    {
      name: "Flagstaff",
      url: "https://www.lonelyplanet.com/usa/southwest/flagstaff",
    },
    {
      name: "Savannah",
      url: "https://www.lonelyplanet.com/usa/the-south/savannah",
    },
    {
      name: "Richmond",
      url: "https://www.lonelyplanet.com/usa/virginia/richmond",
    },
    { name: "Juneau", url: "https://www.lonelyplanet.com/usa/alaska/juneau" },
    {
      name: "Santa Barbara",
      url: "https://www.lonelyplanet.com/usa/california/santa-barbara",
    },
    {
      name: "Fort Lauderdale",
      url: "https://www.lonelyplanet.com/usa/florida/fort-lauderdale",
    },
    {
      name: "Portland",
      url: "https://www.lonelyplanet.com/usa/new-england/portland",
    },
    { name: "Memphis", url: "https://www.lonelyplanet.com/usa/memphis" },
    {
      name: "San Antonio",
      url: "https://www.lonelyplanet.com/usa/texas/san-antonio",
    },
    {
      name: "Salt Lake City",
      url: "https://www.lonelyplanet.com/usa/southwest/salt-lake-city",
    },
    {
      name: "Baltimore",
      url: "https://www.lonelyplanet.com/usa/maryland/baltimore",
    },
    {
      name: "Pittsburgh",
      url: "https://www.lonelyplanet.com/usa/pennsylvania/pittsburgh",
    },
    {
      name: "Asheville",
      url: "https://www.lonelyplanet.com/usa/the-south/asheville",
    },
    {
      name: "Kailuakona",
      url: "https://www.lonelyplanet.com/usa/hawaii/kailua-kona",
    },
    {
      name: "Anchorage",
      url: "https://www.lonelyplanet.com/usa/alaska/anchorage",
    },
    {
      name: "Albuquerque",
      url: "https://www.lonelyplanet.com/usa/southwest/albuquerque",
    },
    {
      name: "Monterey",
      url: "https://www.lonelyplanet.com/usa/california/monterey",
    },
    { name: "Moab", url: "https://www.lonelyplanet.com/usa/southwest/moab" },
    {
      name: "Santa Cruz",
      url: "https://www.lonelyplanet.com/usa/california/santa-cruz",
    },
    {
      name: "St. Louis",
      url: "https://www.lonelyplanet.com/usa/great-plains/st-louis",
    },
    { name: "Taos", url: "https://www.lonelyplanet.com/usa/southwest/taos" },
    { name: "El Paso", url: "https://www.lonelyplanet.com/usa/texas/el-paso" },
    {
      name: "Boulder",
      url: "https://www.lonelyplanet.com/usa/rocky-mountains/boulder",
    },
    {
      name: "Ketchikan",
      url: "https://www.lonelyplanet.com/usa/alaska/ketchikan",
    },
    {
      name: "San Jose",
      url: "https://www.lonelyplanet.com/usa/california/san-jose",
    },
    {
      name: "St. Augustine",
      url: "https://www.lonelyplanet.com/usa/florida/st-augustine",
    },
    {
      name: "Tucson",
      url: "https://www.lonelyplanet.com/usa/southwest/tucson",
    },
    {
      name: "Fairbanks",
      url: "https://www.lonelyplanet.com/usa/alaska/fairbanks",
    },
    { name: "Hanalei", url: "https://www.lonelyplanet.com/usa/hawaii/hanalei" },
  ],
};

export const countries = {
  caribbean: [
    {
      cities: cities.cuba,
      url: "https://www.lonelyplanet.com/cuba",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Cuba.png",
      name: "Cuba",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Haiti.png",
      name: "Haiti",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Dominican-Republic.png",
      name: "Dominican Republic",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Puerto-Rico.png",
      name: "Puerto Rico",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Jamaica.png",
      name: "Jamaica",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Trinidad-and-Tobago.png",
      name: "Trinidad and Tobago",
    },
    { cities: [], url: "#", flag: "", name: "Guadeloupe" },
    { cities: [], url: "#", flag: "", name: "Martinique" },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Bahamas.png",
      name: "Bahamas",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Barbados.png",
      name: "Barbados",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-St-Lucia.png",
      name: "Saint Lucia",
    },
    { cities: [], url: "#", flag: "", name: "Curaçao" },
    { cities: [], url: "#", flag: "", name: "Aruba" },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Grenada.png",
      name: "Grenada",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Antigua.png",
      name: "Antigua and Barbuda",
    },
    { cities: [], url: "#", flag: "", name: "Bermuda" },
  ],
  centralAmerica: [
    {
      cities: cities.guatemala,
      url: "https://www.lonelyplanet.com/guatemala",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Guatemala.png",
      name: "Guatemala",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Honduras.png",
      name: "Honduras",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Nicaragua.png",
      name: "Nicaragua",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-El-Salvador.png",
      name: "El Salvador",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Costa-Rica.png",
      name: "Costa Rica",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Panama.png",
      name: "Panama",
    },
    {
      cities: [],
      url: "#",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Belize.png",
      name: "Belize",
    },
  ],
  northAmerica: [
    {
      cities: cities.usa,
      url: "https://www.lonelyplanet.com/usa",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-United-States-of-America.png",
      name: "United States",
    },
    {
      cities: cities.mexico,
      url: "https://www.lonelyplanet.com/mexico",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Mexico.png",
      name: "Mexico",
    },
    {
      cities: cities.canada,
      url: "https://www.lonelyplanet.com/canada",
      flag:
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/60230/flag-of-Canada.png",
      name: "Canada",
    },
  ],
  southAmerica: [
    {
      cities: [],
      name: "Argentina",
      url: "https://www.lonelyplanet.com/argentina",
    },
    {
      cities: [],
      name: "Bolivia",
      url: "https://www.lonelyplanet.com/bolivia",
    },
    { cities: [], name: "Brazil", url: "https://www.lonelyplanet.com/brazil" },
    { cities: [], name: "Chile", url: "https://www.lonelyplanet.com/chile" },
    {
      cities: [],
      name: "Colombia",
      url: "https://www.lonelyplanet.com/colombia",
    },
    {
      cities: [],
      name: "Ecuador",
      url: "https://www.lonelyplanet.com/ecuador",
    },
    {
      cities: [],
      name: "Paraguay",
      url: "https://www.lonelyplanet.com/paraguay",
    },
    { cities: [], name: "Peru", url: "https://www.lonelyplanet.com/peru" },
    {
      cities: [],
      name: "Suriname",
      url: "https://www.lonelyplanet.com/the-guianas/suriname",
    },
    {
      cities: [],
      name: "Uruguay",
      url: "https://www.lonelyplanet.com/uruguay",
    },
    {
      cities: [],
      name: "Venezuela",
      url: "https://www.lonelyplanet.com/venezuela",
    },
  ],
  europe: [
    {
      cities: [],
      name: "Albania",
      url: "https://www.lonelyplanet.com/albania",
    },
    {
      cities: [],
      name: "Andorra",
      url: "https://www.lonelyplanet.com/andorra",
    },
    {
      cities: [],
      name: "Armenia",
      url: "https://www.lonelyplanet.com/armenia",
    },
    {
      cities: [],
      name: "Austria",
      url: "https://www.lonelyplanet.com/austria",
    },
    {
      cities: [],
      name: "Azerbaijan",
      url: "https://www.lonelyplanet.com/azerbaijan",
    },
    {
      cities: [],
      name: "Belarus",
      url: "https://www.lonelyplanet.com/belarus",
    },
    {
      cities: [],
      name: "Belgium",
      url: "https://www.lonelyplanet.com/belgium",
    },
    {
      cities: [],
      name: "Bosnia",
      url: "https://www.lonelyplanet.com/bosnia-and-hercegovina",
    },
    {
      cities: [],
      name: "Bulgaria",
      url: "https://www.lonelyplanet.com/bulgaria",
    },
    {
      cities: [],
      name: "Croatia",
      url: "https://www.lonelyplanet.com/croatia",
    },
    {
      cities: [],
      name: "Cyprus",
      url: "https://www.lonelyplanet.com/cyprus/the-republic-of-cyprus",
    },
    {
      cities: [],
      name: "Czech Republic",
      url: "https://www.lonelyplanet.com/czech-republic",
    },
    {
      cities: [],
      name: "Denmark",
      url: "https://www.lonelyplanet.com/denmark",
    },
    {
      cities: [],
      name: "England",
      url: "https://www.lonelyplanet.com/england",
    },
    {
      cities: [],
      name: "Estonia",
      url: "https://www.lonelyplanet.com/estonia",
    },
    {
      cities: [],
      name: "Finland",
      url: "https://www.lonelyplanet.com/finland",
    },
    { cities: [], name: "France", url: "https://www.lonelyplanet.com/france" },
    {
      cities: [],
      name: "Georgia",
      url: "https://www.lonelyplanet.com/georgia",
    },
    {
      cities: [],
      name: "Germany",
      url: "https://www.lonelyplanet.com/germany",
    },
    { cities: [], name: "Greece", url: "https://www.lonelyplanet.com/greece" },
    {
      cities: [],
      name: "Greenland",
      url: "https://www.lonelyplanet.com/greenland",
    },
    {
      cities: [],
      name: "Hungary",
      url: "https://www.lonelyplanet.com/hungary",
    },
    {
      cities: [],
      name: "Iceland",
      url: "https://www.lonelyplanet.com/iceland",
    },
    {
      cities: [],
      name: "Ireland",
      url: "https://www.lonelyplanet.com/ireland",
    },
    { cities: [], name: "Italy", url: "https://www.lonelyplanet.com/italy" },
    { cities: [], name: "Kosovo", url: "https://www.lonelyplanet.com/kosovo" },
    { cities: [], name: "Latvia", url: "https://www.lonelyplanet.com/latvia" },
    {
      cities: [],
      name: "Liechtenstein",
      url: "https://www.lonelyplanet.com/liechtenstein",
    },
    {
      cities: [],
      name: "Lithuania",
      url: "https://www.lonelyplanet.com/lithuania",
    },
    {
      cities: [],
      name: "Luxembourg",
      url: "https://www.lonelyplanet.com/luxembourg",
    },
    {
      cities: [],
      name: "Macedonia",
      url: "https://www.lonelyplanet.com/macedonia",
    },
    { cities: [], name: "Malta", url: "https://www.lonelyplanet.com/malta" },
    {
      cities: [],
      name: "Moldova",
      url: "https://www.lonelyplanet.com/moldova",
    },
    {
      cities: [],
      name: "Montenegro",
      url: "https://www.lonelyplanet.com/montenegro",
    },
    {
      cities: [],
      name: "Northern Ireland",
      url: "https://www.lonelyplanet.com/ireland/northern-ireland",
    },
    { cities: [], name: "Norway", url: "https://www.lonelyplanet.com/norway" },
    { cities: [], name: "Poland", url: "https://www.lonelyplanet.com/poland" },
    {
      cities: [],
      name: "Portugal",
      url: "https://www.lonelyplanet.com/portugal",
    },
    {
      cities: [],
      name: "Romania",
      url: "https://www.lonelyplanet.com/romania",
    },
    { cities: [], name: "Russia", url: "https://www.lonelyplanet.com/russia" },
    {
      cities: [],
      name: "Scotland",
      url: "https://www.lonelyplanet.com/scotland",
    },
    { cities: [], name: "Serbia", url: "https://www.lonelyplanet.com/serbia" },
    {
      cities: [],
      name: "Slovakia",
      url: "https://www.lonelyplanet.com/slovakia",
    },
    {
      cities: [],
      name: "Slovenia",
      url: "https://www.lonelyplanet.com/slovenia",
    },
    { cities: [], name: "Spain", url: "https://www.lonelyplanet.com/spain" },
    { cities: [], name: "Sweden", url: "https://www.lonelyplanet.com/sweden" },
    {
      cities: [],
      name: "Switzerland",
      url: "https://www.lonelyplanet.com/switzerland",
    },
    {
      cities: [],
      name: "The Netherlands",
      url: "https://www.lonelyplanet.com/the-netherlands",
    },
    { cities: [], name: "Turkey", url: "https://www.lonelyplanet.com/turkey" },
    {
      cities: [],
      name: "Ukraine",
      url: "https://www.lonelyplanet.com/ukraine",
    },
    { cities: [], name: "Wales", url: "https://www.lonelyplanet.com/wales" },
  ],
  africa: [
    { name: "Algeria", url: "https://www.lonelyplanet.com/algeria" },
    { name: "Benin", url: "https://www.lonelyplanet.com/benin" },
    { name: "Botswana", url: "https://www.lonelyplanet.com/botswana" },
    { name: "Burkina Faso", url: "https://www.lonelyplanet.com/burkina-faso" },
    { name: "Cabo Verde", url: "https://www.lonelyplanet.com/cabo-verde" },
    { name: "Cote Divoire", url: "https://www.lonelyplanet.com/cote-divoire" },
    {
      name: "Democratic Republic of Congo",
      url: "https://www.lonelyplanet.com/democratic-republic-of-congo",
    },
    { name: "Djibouti", url: "https://www.lonelyplanet.com/djibouti" },
    { name: "Egypt", url: "https://www.lonelyplanet.com/egypt" },
    { name: "Eritrea", url: "https://www.lonelyplanet.com/eritrea" },
    { name: "Ethiopia", url: "https://www.lonelyplanet.com/ethiopia" },
    { name: "Gabon", url: "https://www.lonelyplanet.com/gabon" },
    { name: "Ghana", url: "https://www.lonelyplanet.com/ghana" },
    { name: "Guinea", url: "https://www.lonelyplanet.com/guinea" },
    { name: "Kenya", url: "https://www.lonelyplanet.com/kenya" },
    { name: "Liberia", url: "https://www.lonelyplanet.com/liberia" },
    { name: "Madagascar", url: "https://www.lonelyplanet.com/madagascar" },
    { name: "Mauritius", url: "https://www.lonelyplanet.com/mauritius" },
    { name: "Morocco", url: "https://www.lonelyplanet.com/morocco" },
    { name: "Mozambique", url: "https://www.lonelyplanet.com/mozambique" },
    { name: "Namibia", url: "https://www.lonelyplanet.com/namibia" },
    { name: "Nigeria", url: "https://www.lonelyplanet.com/nigeria" },
    { name: "Republic of Congo", url: "https://www.lonelyplanet.com/congo" },
    { name: "Rwanda", url: "https://www.lonelyplanet.com/rwanda" },
    { name: "Senegal", url: "https://www.lonelyplanet.com/senegal" },
    { name: "Seychelles", url: "https://www.lonelyplanet.com/seychelles" },
    { name: "South Africa", url: "https://www.lonelyplanet.com/south-africa" },
    { name: "Sudan", url: "https://www.lonelyplanet.com/sudan" },
    { name: "Tanzania", url: "https://www.lonelyplanet.com/tanzania" },
    { name: "The Gambia", url: "https://www.lonelyplanet.com/the-gambia" },
    { name: "Togo", url: "https://www.lonelyplanet.com/togo" },
    { name: "Tunisia", url: "https://www.lonelyplanet.com/tunisia" },
    { name: "Uganda", url: "https://www.lonelyplanet.com/uganda" },
    { name: "Zambia", url: "https://www.lonelyplanet.com/zambia" },
    { name: "Zimbabwe", url: "https://www.lonelyplanet.com/zimbabwe" },
  ],
};

export const destinations = [
  {
    countries: countries.northAmerica,
    name: "North America",
    url: "https://www.lonelyplanet.com/north-america",
  },
  {
    countries: countries.caribbean,
    name: "Caribbean",
    url: "https://www.lonelyplanet.com/caribbean",
  },
  {
    countries: countries.centralAmerica,
    name: "Central America",
    url: "https://www.lonelyplanet.com/central-america",
  },
  {
    countries: countries.southAmerica,
    name: "South America",
    url: "https://www.lonelyplanet.com/south-america",
  },
  {
    countries: countries.europe,
    name: "Europe",
    url: "https://www.lonelyplanet.com/europe",
  },
  { countries: [], name: "Asia", url: "https://www.lonelyplanet.com/asia" },
  {
    countries: [],
    name: "Pacific",
    url: "https://www.lonelyplanet.com/pacific",
  },
  {
    countries: countries.africa,
    name: "Africa",
    url: "https://www.lonelyplanet.com/africa",
  },
  {
    countries: [],
    name: "Middle East",
    url: "https://www.lonelyplanet.com/middle-east",
  },
  {
    countries: [],
    name: "Antarctica",
    url: "https://www.lonelyplanet.com/antarctica-1007062",
  },
];

export const menu = [
  {
    submenu: destinations,
    name: "Destinations",
    url: "https://www.lonelyplanet.com/places",
  },
  {
    submenu: bookings,
    name: "Bookings",
    url: "https://www.lonelyplanet.com/bookings",
  },
  { submenu: [], name: "Shop", url: "https://shop.lonelyplanet.com/" },
  {
    submenu: [],
    name: "Community",
    url: "https://www.lonelyplanet.com/thorntree",
  },
];

export const userMenu = [
  { name: "Profile", url: "/profile" },
  { name: "Settings", url: "/profile/settings" },
  { name: "Lists", url: "/profile/lists" },
  { name: "Sign out", url: "/profile/sign-out" },
];
